// Container
import withCellPopover from '../../../molecules/withCellPopover';

// Components
import { Select } from '../../../molecules/advancedSelect';
var SelectInputCellRenderer = withCellPopover(Select);
export default SelectInputCellRenderer;